import type { Endpoint } from '../hooks/useEndpoints';

/** The classes the endpoint classifier writes, as a person reads them. */
export const ENDPOINT_CLASSES: { value: string; label: string }[] = [
  { value: 'network_gear', label: 'Network gear' },
  { value: 'wireless_ap', label: 'Wireless AP' },
  { value: 'wireless_client', label: 'Wireless client' },
  { value: 'workstation', label: 'Workstation' },
  { value: 'server', label: 'Server' },
  { value: 'voip_phone', label: 'VoIP phone' },
  { value: 'printer', label: 'Printer' },
  { value: 'camera', label: 'Camera' },
  { value: 'iot', label: 'IoT device' },
  { value: 'unknown', label: 'Unknown' },
];

/** An endpoint class's name. A class this build does not know still reads as words. */
export function endpointClassLabel(value: string | null | undefined): string {
  if (!value) return 'Unknown';
  return ENDPOINT_CLASSES.find((c) => c.value === value)?.label ?? value.replace(/_/g, ' ');
}

/** What an endpoint is called on the map and in its panels: hostname, else vendor, else MAC. */
export function endpointLabel(endpoint: Pick<Endpoint, 'hostname' | 'ouiVendor' | 'macAddress'>): string {
  return endpoint.hostname ?? endpoint.ouiVendor ?? endpoint.macAddress;
}
